import React from "react";
import { TruncatedText } from "../truncated-text/truncated-text";

export function DashboardRenderOverridable(field: string) {
  return function (info: any) {
    const value = info?.row?.original?.[field];
    return <TruncatedText text={value} />;
  };
}
